const isSelected = (location, url, onlyActiveOnIndex = false) => {
  const isActive = onlyActiveOnIndex
    ? location.pathname === url
    : url.startsWith(location.pathname);

  return isActive;
};
export default isSelected;
